<template>
  <div class="wrapper">

    <h1 class="main-title">
      {{ topTitle }}
    </h1>

    <div class="section-wrapper">

      <!-- =======================
           ROW 1 (image | text)
      ======================== -->
      <div class="row row-1">
        <div class="col image-col">
          <img :src="imgLeft" class="glow-img" />
        </div>

        <div class="col text-col">
          <h2 class="text-center">{{ content1.title }}</h2>
          <p class="text-justify">{{ content1.desc }}</p>
        </div>
      </div>

      <!-- =======================
           ROW 2 (text | image)
      ======================== -->
      <!-- <div class="row row-2">
        <div class="col text-col">
          <h2>{{ content2.title }}</h2>
          <p>{{ content2.desc }}</p>
        </div>

        <div class="col image-col">
          <img :src="imgRight" class="glow-img" />
        </div>
      </div> -->

    </div>

  </div>
</template>

<script>
import imgLeft from "./../assets/Jimmy-1.png"
import imgRight from "./../assets/right.png"

export default {
  props: ["lang"],

  data() {
    return {
      imgLeft,
      imgRight,
      topTitle: "",

      content1: { title: "", desc: "" },
      content2: { title: "", desc: "" }
    }
  },

  watch: {
    lang: {
      immediate: true,
      handler(v) {
        if (v === "id") {
          this.topTitle = "ʚ Sesuatu yang Ingin Aku Bagikan ɞ"

          // content1 — UPDATED INDONESIA
          this.content1.title = "Terima Kasih Telah Mampir"
          this.content1.desc =
            "Baiklah jadi saya yakin ketika kalian lihat gambar-gambarnya itu memang benar bahwa rata-rata adalah AI. Sementara saya biarkan mayoritas gambarnya adalah AI supaya saya tidak terkena hak cipta. Saya bekerja sendirian dalam website ini jadi hampir mustahil saya bisa melakukan semuanya sendiri. Saya tetap pastikan ada sentuhan manusia (diri saya sendiri), tetapi saya juga perlu AI; kalau tidak, bisa jadi saya akan stuck di suatu tempat terlalu lama. Terima kasih atas perhatiannya."

          // content2 — TIDAK DIUBAH
          this.content2.title = "Mengapa Kamu Butuh Ini?"
          this.content2.desc =
            "Dengan fitur canggih dan desain modern, produk ini memberikan nilai lebih."
        } else {
          this.topTitle = "ʚ Something I Want to Share ɞ"

          // content1 — UPDATED ENGLISH VERSION
          this.content1.title = "Thank You for Stopping By"
          this.content1.desc =
            "Alright, so I’m pretty sure when you look at the images, you’ll notice that most of them are indeed AI-generated. I’m keeping the majority of the images AI-made for now to avoid any copyright issues. I’m working on this entire website alone, so it’s nearly impossible for me to handle everything by myself. I still make sure there's human touch (from myself), but I also need AI—otherwise I might get stuck on one part for too long. Thank you for your understanding."

          // content2 — TIDAK DIUBAH
          this.content2.title = "Why Do You Need This?"
          this.content2.desc =
            "With advanced features and modern design, this product offers great value."
        }
      }
    }
  }
}
</script>

<style scoped>
/* Wrapper */
.wrapper {
  width: 100%;
  padding: 40px 20px;
}

.main-title {
  text-align: center;
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 50px;
}

/* Section stack */
.section-wrapper {
  display: flex;
  flex-direction: column;
  gap: 100px;
}

/* ======================
   FIX FINAL: USE GRID
   ====================== */
.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;

  align-items: center;
  max-width: 1150px;
  margin: 0 auto;
}

/* Column style */
.col {
  width: 100%;
}

/* Image column */
.image-col img {
  width: 70%;
  margin: 0 auto;
  border-radius: 22px;

  filter: drop-shadow(0 0 18px rgba(255, 255, 255, 0.85))
          drop-shadow(0 0 40px rgba(255, 185, 255, 0.55))
          drop-shadow(0 20px 30px rgba(0, 0, 0, 0.25));

  animation: float 4s ease-in-out infinite;
}

@keyframes float {
  0% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
  100% { transform: translateY(0); }
}

/* Text block */
.text-col h2 {
  font-size: 28px;
  font-weight: 800;
  margin-bottom: 12px;
}

.text-col p {
  font-size: 18px;
  line-height: 1.7;
  color: #6a5c7a;
}

/* Mobile responsive */
@media (max-width: 900px) {
  .row {
    grid-template-columns: 1fr;
  }

  /* Stack: always image → text for mobile */
  .row-1 .image-col { order: 1; }
  .row-1 .text-col  { order: 2; }

  .row-2 .text-col  { order: 1; }
  .row-2 .image-col { order: 2; }
}
</style>
